export const HamMenuIcon = () => {
  return (
    <svg
      width='13'
      height='13'
      viewBox='0 0 13 7'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M0.25 0.964286C0.25 0.569793 0.50888 0.25 0.828218 0.25H11.8144C12.1337 0.25 12.3926 0.569793 12.3926 0.964286C12.3926 1.35878 12.1337 1.67857 11.8144 1.67857H0.828218C0.50888 1.67857 0.25 1.35878 0.25 0.964286Z'
        fill='currentColor'
        stroke='currentColor'
        strokeWidth='0.5'
      />
      <path
        d='M0.25 5.96436C0.25 5.56986 0.50888 5.25 0.828218 5.25L7.18861 5.25021C7.50796 5.25021 7.76683 5.57 7.76683 5.9645C7.76683 6.359 7.50796 6.67879 7.18861 6.67879L0.828218 6.67864C0.50888 6.67864 0.25 6.35879 0.25 5.96436Z'
        fill='currentColor'
        stroke='currentColor'
        strokeWidth='0.5'
      />
    </svg>
  )
}
